// extracted by mini-css-extract-plugin
export default {"loader":"spinner_loader__OOA8t","shadow324":"spinner_shadow324__xs7Nt","jump7456":"spinner_jump7456__ghDzD"};